import { ISmartMapFilterType } from '../../../models/GenericMapModels.model';
import genericMapConstants from './genericMapConstants';

const initialState = {
  genericMapRoutes: [],
  genericMapAgreements: [],
  genericMapAgreementLines: [],
  genericMapRouteLines: [],
  genericMapPlaces: [],

  displayedGenericMapAgreements: [],
  displayedGenericMapAgreementLines: [],
  displayedGenericMapRouteLines: [],
  displayedGenericMapPlaces: [],

  genericMapUsedRoutes: [],
  genericMapDrawnShapes: [],
  routeIds: [],
  error: null,
  genericMapLayers: {
    agreementsLayer: true,
    routesLayer: true,
    placesLayer: true,
    binsLayer: true,
  },
  mapCorners: [],
  isAgreementsVisible: false,
  zoomLevel: null,
  isWarningBannerHidden: true,

  highlightedMarkers: {
    category: null,
    value: null,
  },
  filterType: ISmartMapFilterType.EXTENT,
  smartMapActionTypes: [],
  selectedSmartMapAction: null,
};

export default function genericMapReducer(state = initialState, action) {
  switch (action.type) {
    // ----- ROUTES -----
    case genericMapConstants.GET_GENERIC_MAP_ROUTES_SUCCESS:
      return {
        ...state,
        genericMapRoutes: action.genericMapRoutes,
        routeIds: action.routeIds,
        error: null,
      };
    case genericMapConstants.GET_GENERIC_MAP_ROUTES_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    // ----- DATA -----
    case genericMapConstants.GET_GENERIC_MAP_DATA_SUCCESS:
      return {
        ...state,
        genericMapAgreements: action.genericMapData.agreements,
        genericMapPlaces: action.genericMapData.places,
        genericMapAgreementLines: action.genericMapData.agreementLines,
        genericMapRouteLines: action.genericMapData.routeLines,
        genericMapUsedRoutes: action.genericMapData.routes,

        error: null,
      };
    case genericMapConstants.GET_GENERIC_MAP_DATA_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    // ----- GET DRAWN SHAPES -----
    case genericMapConstants.GET_GENERIC_MAP_DRAWN_SHAPES_SUCCESS:
      return {
        ...state,
        genericMapDrawnShapes: action.genericMapDrawnShapes,
        error: null,
      };
    case genericMapConstants.GET_GENERIC_MAP_DRAWN_SHAPES_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    // ----- SET DRAWN SHAPES -----
    case genericMapConstants.SET_GENERIC_MAP_DRAWN_SHAPES_SUCCESS:
      return {
        ...state,
        // update the drawn shapes in the store if needed
        // for example, if your endpoint returns updated shapes
        genericMapDrawnShapes: action.updatedShapes,
        error: null,
      };
    case genericMapConstants.SET_GENERIC_MAP_DRAWN_SHAPES_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case genericMapConstants.SET_GENERIC_MAP_LAYERS:
      return {
        ...state,
        genericMapLayers: action.layers,
      };
    case genericMapConstants.SET_MAP_CORNER_COORDINATES:
      return {
        ...state,
        mapCorners: action.mapCorners,
      };
    case genericMapConstants.SET_AGREEMENTS_VISIBLE_FLAG:
      return {
        ...state,
        isAgreementsVisible: action.isVisible,
      };
    case genericMapConstants.SET_ZOOM_LEVEL:
      return {
        ...state,
        zoomLevel: action.zoomLevel,
      };
    case genericMapConstants.SET_ZOOM_WARNING_BANNER_VISIBILITY:
      return {
        ...state,
        isWarningBannerHidden: action.isHidden,
      };
    case genericMapConstants.SET_DISPLAYED_MAP_DATA:
      return {
        ...state,
        displayedGenericMapAgreements: action.displayedData.agreements,
        displayedGenericMapAgreementLines: action.displayedData.agreementLines,
        // displayedGenericMapRouteLines: action.displayedData.routeLines,
        displayedGenericMapPlaces: action.displayedData.places,
      };
    case genericMapConstants.SET_HIGHLIGHTED_MARKERS:
      return {
        ...state,
        highlightedMarkers: action.highlights,
      };
    case genericMapConstants.SET_FILTER_TYPE:
      return {
        ...state,
        filterType: action.filterType,
      };
    case genericMapConstants.GET_GENERIC_MAP_ACTION_TYPES_SUCCESS:
      return {
        ...state,
        smartMapActionTypes: action.genericMapActionTypes,
      };
    case genericMapConstants.GET_GENERIC_MAP_ACTION_TYPES_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case genericMapConstants.GET_GENERIC_MAP_ACTION_SUCCESS:
      return {
        ...state,
        selectedSmartMapAction: action.action,
      };
    case genericMapConstants.GET_GENERIC_MAP_ACTION_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case genericMapConstants.GET_GENERIC_MAP_ACTION_REQUEST:
      return {
        ...state,
        selectedSmartMapAction: null,
      };
    default:
      return state;
  }
}
